import styles from './InviteButton.module.css'

/**
 * "Invite a friend or team mate" — opens the user's own mail client.
 *
 * Deliberately a `mailto:` link and not a form: there is no invitation system
 * behind it, no seat, no pending state and no email we send. Building any of
 * that to make the button look richer would be a control that promises a
 * capability the product does not have. The user writes the mail themselves,
 * from their own address, which is also the version most likely to be read.
 *
 * An anchor rather than a button with an onClick, so it behaves like a link:
 * middle-click, copy-address and a mail client that opens in a new window all
 * work without a line of code.
 */

/** The public address the invited person lands on. */
const SITE = 'https://yourdealpulse.com'

/**
 * Mike's copy, given 2026-09-03, verbatim. The one substitution is his
 * `[Invitation Link]` placeholder: there is no invitation link to mint — no
 * token, no seat, no pending state — so it is the public address, which is
 * where an invited person can actually start.
 *
 * The subject is not his; he gave the body only. "DealPulse" is deliberately
 * plain: this arrives from a person the recipient knows, and the first line of
 * the body is what their mail client shows as the preview.
 */
const SUBJECT = 'YourDealPulse'
const BODY = `Hi,

I came across a tool recently that I've been using for reviewing sales calls, and it made me think of you.

It's called YourDealPulse. You upload a call transcript, and it shows what was actually confirmed during the conversation, where the deal stands, and whether it's worth continuing to invest time in the opportunity.

If you're curious, you can try it here:

${SITE}

Regards,`

function mailto(): string {
  return `mailto:?subject=${encodeURIComponent(SUBJECT)}&body=${encodeURIComponent(BODY)}`
}

export function InviteButton() {
  return (
    <a className={styles.invite} href={mailto()}>
      Invite a friend or team mate
    </a>
  )
}
